export default function getLocalization(stringKey) {
  if (typeof window.ritolakosalmi_screenReaderText === 'undefined' || typeof window.ritolakosalmi_screenReaderText[stringKey] === 'undefined') {
    // eslint-disable-next-line no-console
    console.error(`Missing translation for ${stringKey}`);
    return '';
  }
  return window.ritolakosalmi_screenReaderText[stringKey];
}
